import { useCallback } from 'react';
import { useParams, useSearchParams } from 'react-router-dom';

import useWorkspaceRouter from '@/hooks/domain/useWorkspaceRouter';
import useFetch from '@/hooks/pure/useFetch';
import useDetailModalStore, {
  DETAIL_MODAL_TYPE,
} from '@/stores/pure/DetailModalStore';

const FeedbackDetailRedirection = () => {
  const setNewModal = useDetailModalStore((state) => state.setNewModal);
  const feedback_alias = useParams().feedback_alias as string;
  const [searchParams] = useSearchParams();
  const block_alias = searchParams.get('block_alias') as string;
  const wc = useWorkspaceRouter();

  const handleRoute = useCallback(async () => {
    if (!feedback_alias) return;
    setNewModal({
      alias: feedback_alias,
      type: DETAIL_MODAL_TYPE.FEEDBACK,
      idx: 0,
      options: {
        focusedBlock: block_alias,
      },
    });

    wc.push(`/feedbacks`, {
      replace: true,
    });
  }, [feedback_alias, block_alias]);

  useFetch(handleRoute);

  return null;
};

export default FeedbackDetailRedirection;
